import { render, staticRenderFns } from "./MensajeInput.vue?vue&type=template&id=82d51dcc"
import script from "./MensajeInput.vue?vue&type=script&lang=js"
export * from "./MensajeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports